module.exports = __webpack_public_path__ + "static/media/avatar_4.a130ef9d.svg";